import React from 'react';
import { Button, Input, Modal } from 'AWS-UI-Components-React';

export class SaveCognosConfigWindow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      comment: this.props.comment,
    };
  }

  onCancel = () => {
    this.props.onCancel();
  };

  onSubmit = () => {
    const { payload } = this.props;
    const payloadWithComment = payload.map((p) => {
      return { ...p, comment: this.state.comment ? this.state.comment : this.props.comment };
    });

    this.setState({ comment: null });
    this.props.onSubmit(payloadWithComment);
  };

  onUpdateComment = (event) => {
    this.setState({ comment: event.detail.value });
  };

  render() {
    const { visible, comment } = this.props;

    return (
      <Modal
        visible={visible}
        size="large"
        header="Save Cognos Config"
        expandToFit={true}
        onDismiss={this.onCancel}
        footer={
          <div>
            <span className="awsui-util-f-r">
              <Button text="Cancel" onClick={this.onCancel} />
              <Button variant="primary" text="Save Changes" onClick={this.onSubmit} />
            </span>
          </div>
        }
        content={
          <div>
            <h3>Comments:</h3>
            <div>
              <Input value={comment} onChange={this.onUpdateComment} />
            </div>
          </div>
        }
      />
    );
  }
}

export default SaveCognosConfigWindow;



// WEBPACK FOOTER //
// ./src/components/config_central/cognos_config/save_cognos_config.jsx